import handleSystemCall from '../CommonMethods/SystemConfigCall'

const apiMiddleware = store => next => action => {
    // Check if the dispatched action is related to an API call
    if (action.type.endsWith('fulfilled')) { // Assuming you're using Redux Toolkit's fulfilled action suffix
    // Execute handleSystemCall() after the completion of the API call
        handleSystemCall();
    }
    return next(action);
};

export default apiMiddleware;